<template>
  <el-dialog
    class="customDialogForm"
    width="600px"
    title="服务升级"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <el-alert style="margin-bottom: 16px" type="success" title="如果版本增加，将进行部署应用的滚动升级" />
    <el-form
      autocomplete="on"
      style="padding: 0 90px;"
      ref="Forms"
      label-position="left"
      :model="captchaForm"
      @submit.native.prevent
    >
      <el-form-item prop="appname" label="应用名称" :label-width="formLabelWidth">
        <el-input
          :disabled="true"
          style="width: 100%;line-height: 37px;"
          v-model="captchaForm.name"
        />
      </el-form-item>
      <el-form-item prop="name" label="套餐选择:" :label-width="formLabelWidth">
        <el-select v-model="curPackageInfo.packageID" placeholder="请选择">
          <el-option
            v-for="item in packages"
            :key="item.packageID"
            :label="item.name+'('+item.version+')'"
            :value="item.packageID"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ServiceUpgrade',
  props: {
    dialogVisible: {
      type: Boolean,
      default: true
    },
    appDetail: {
      type: Object,
      default: () => null
    },
    packages: {
      type: Array,
      default: () => null
    }
  },
  data() {
    return {
      Loading: false,
      formLabelWidth: '100px',
      captchaForm: {
        num: 1,
        captcha_id: '',
        captcha_answer: '',
        price: 0,
        billCycle: '',
        name: ''
      },
      totalPrice: 0,
      billCycles: [
        {
          label: '周',
          value: 'week'
        },
        {
          label: '月度',
          value: 'month'
        },
        {
          label: '季度',
          value: 'quarter'
        },
        {
          label: '年度',
          value: 'year'
        }
      ],
      value: '',
      loading: false,
      versionList: [],
      curVersion: '',
      curVersionPackageList: [],
      allPackageInfo: {},
      curPackageInfo: {},
      showDateZh: { month: '月', year: '年', quarter: '季度', week: '周' }
    };
  },
  created() {
    if (this.appDetail) {
      const { combo, appName } = this.appDetail;
      if (combo) {
        this.captchaForm.billCycle = combo.billCycle;
        this.captchaForm.price = combo.price;
        this.totalPrice = combo.price;
      }
      this.captchaForm.name = appName;
    }
  },
  methods: {
    submit() {
      this.$refs.Forms.validate((valid) => {
        if (valid) {
          this.Loading = true;
          const { appID, marketID } = this.appDetail;
          const obj = {
            marketID,
            appID: appID,
            comboID: this.curPackageInfo.packageID
          };
          this.$store
            .dispatch('MerchantsAppUpgrade', obj)
            .then((res) => {
              this.Loading = false;
              this.handleClose(true, true);
              this.$message.success('升级成功');
            })
            .catch(() => {
              this.Loading = false;
            });
        }
      });
    },
    handleChange() {
      const { price, num } = this.captchaForm;
      this.totalPrice = price * num;
    },
    handleClose(_, updata = false) {
      this.$emit('handleClose', updata);
      this.$refs.Forms.resetFields();
    }
  }
};
</script>

<style lang="scss">
.input-with-select .el-input-group__prepend {
  background: #f9f9f9;
}
.verification-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/deliverManage/apps/components/upgrade.vue